import React from "react"
import PropTypes from 'prop-types'

import {FieldAutomationActionFormProps} from "../../../../render/automation-action-form";
import EditableInput from "../../../string/render/inline-editable/input-component";

const debug = false
// const debug = "NumberActionForm"

export default class FieldNumber_AutomationActionForm extends React.Component<FieldAutomationActionFormProps, any> {

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        onChangeCallback: PropTypes.func,
    }

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue: _.get(props.config, 'toValue', null)
        }
    }

    onChangeToValue = (toValue:any) => {
        this.setState({
            toValue
        }, ()=>{
            this.props.onChangeCallback({toValue})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <React.Fragment>
                <div className="flex-row-left-top">
                    <div className={labelClasses}>to</div>
                    <EditableInput className        = "ui5-txt-default ui5-field-form-editable w-200 h-36 p-l-10 p-r-10"
                                   inputClassName   = "ui5-txt-default"
                                   placeholder      = "Value"
                                   type             = "number"
                                   value            = {this.state.toValue}
                                   onChange         = {this.onChangeToValue}/>
                </div>
            </React.Fragment>
        )
    }
}
